import Logo from '../Logo/Logo';
import './SiteHeader.css';

function SiteHeader() {
  return (
    <header className="site-header">
      <Logo />
      <nav aria-label="Primary navigation">
        <a href="/#how">How it works</a>
        <a href="/#exercises">Exercises</a>
        <a href="/privacy">Privacy</a>
        <a href="/terms">Terms</a>
      </nav>
      <a className="header-download" href="/#download">Download the app</a>
    </header>
  );
}

export default SiteHeader;
